export default {
  CryptoBalance: 'Kripto Bakiyeler',
  Displayedcurrencies: 'Görüntülenen para birimleri',
};
